import { render } from "./AmbulanceTrackerPublic.vue?vue&type=template&id=4c2ada4e&scoped=true"
import script from "./AmbulanceTrackerPublic.vue?vue&type=script&lang=js"
export * from "./AmbulanceTrackerPublic.vue?vue&type=script&lang=js"

import "./AmbulanceTrackerPublic.vue?vue&type=style&index=0&id=4c2ada4e&scoped=true&lang=css"

import exportComponent from "/Applications/PROJECTS/HMS-MAIN/PORTAL/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c2ada4e"]])

export default __exports__